module.exports = __webpack_public_path__ + "static/media/Project-Etc.65f3e7c6.svg";